import { render } from "./IntegrationWidget.vue?vue&type=template&id=0f47ecbf"
import script from "./IntegrationWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegrationWidget.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/integration/components/IntegrationWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f47ecbf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f47ecbf', __exports__)) {
    api.reload('0f47ecbf', __exports__)
  }
  
  module.hot.accept("./IntegrationWidget.vue?vue&type=template&id=0f47ecbf", () => {
    api.rerender('0f47ecbf', render)
  })

}


export default __exports__